import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import { NosotrosPage } from './pages/NosotrosPage';
import { ParticipantesPage } from './pages/ParticipantesPage';
import { PrivacidadPage } from './pages/PrivacidadPage';
import { TerminosPage } from './pages/TerminosPage';
import { CookiesPage } from './pages/CookiesPage';
function HomePage() {
  return <>
      <HeroSection data-id="element-0" />
      <HowItWorks data-id="element-1" />
      <CTASection data-id="element-2" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-3">
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-brand-gold selection:text-brand-navy" data-id="element-4">
        <Navbar data-id="element-5" />
        <main data-id="element-6">
          <Routes data-id="element-7">
            <Route path="/" element={<HomePage data-id="element-9" />} data-id="element-8" />
            <Route path="/nosotros" element={<NosotrosPage data-id="element-11" />} data-id="element-10" />
            <Route path="/participantes" element={<ParticipantesPage data-id="element-13" />} data-id="element-12" />
            <Route path="/politica-de-privacidad" element={<PrivacidadPage data-id="element-15" />} data-id="element-14" />
            <Route path="/terminos-de-uso" element={<TerminosPage data-id="element-17" />} data-id="element-16" />
            <Route path="/cookies" element={<CookiesPage data-id="element-19" />} data-id="element-18" />
          </Routes>
        </main>
        <Footer data-id="element-20" />
        <CookieBanner data-id="element-21" />
      </div>
    </BrowserRouter>;
}